'use client';

interface IRadioLabelProps {
  htmlFor: string;
  children: string;
}

export const RadioLabel = ({ htmlFor, children }: IRadioLabelProps) => (
  <label className="text-md radio-label cursor-pointer" htmlFor={htmlFor}>
    {children}
  </label>
);
